"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayUtilities = getDisplayUtilities;
exports.default = exports.defaultProps = void 0;
var _breakpoints = require("@bootstrap-styled/css-mixins/lib/breakpoints");
var defaultProps = {
  '$grid-breakpoints': {
    xs: '0',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
  }
};
exports.defaultProps = defaultProps;
function getDisplayUtilities() {
  var gridBreakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultProps['$grid-breakpoints'];
  var utilityList = [];
  Object.keys(gridBreakpoints).forEach(function (breakpoint) {
    var infix = (0, _breakpoints.breakpointInfix)(breakpoint, gridBreakpoints);
    utilityList.push("\n      ".concat((0, _breakpoints.mediaBreakpointUp)(breakpoint, gridBreakpoints, "\n        .d".concat(infix, "-none { display: none !important; }\n        .d").concat(infix, "-inline { display: inline !important; }\n        .d").concat(infix, "-inline-block { display: inline-block !important; }\n        .d").concat(infix, "-block { display: block !important; }\n        .d").concat(infix, "-table { display: table !important; }\n        .d").concat(infix, "-table-cell { display: table-cell !important; }\n        .d").concat(infix, "-flex { display: flex !important; }\n        .d").concat(infix, "-inline-flex { display: inline-flex !important; }\n      ")), "\n    "));
  });
  utilityList.push("\n    .d-print-block {\n      display: none !important;\n    \n      @media print {\n        display: block !important;\n      }\n    }\n    \n    .d-print-inline {\n      display: none !important;\n    \n      @media print {\n        display: inline !important;\n      }\n    }\n    \n    .d-print-inline-block {\n      display: none !important;\n    \n      @media print {\n        display: inline-block !important;\n      }\n    }\n    \n    .d-print-none {\n      @media print {\n        display: none !important;\n      }\n    }\n  ");
  return utilityList.join('\n');
}
var _default = {
  defaultProps: defaultProps,
  getDisplayUtilities: getDisplayUtilities
};
exports.default = _default;